import classNames from 'classnames';

import useStyles from './styles';
import ICard from './types';

function Card({ className, children, onClick }: ICard) {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, 'fs-16', className)} onClick={onClick}>
      {children}
    </div>
  );
}

export default Card;
